var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// @ts-ignore
import * as oauth2 from 'oauth4webapi';
import { LocalStorageKey, NgLocalStorageKey } from 'shared-types/SharedEnums';
var NS = 'OAuth2Service';
var LOCAL_STORAGE_REFRESH_VERSION = 'localStorageRefreshVersion';
var POPUP_WINDOW_CONFIGURE = "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=400,height=550,left=-1000,top=-1000";
var SYNCED_LOGOUT = 'syncedLogout';
var OAuth2Service = /** @class */ (function () {
    function OAuth2Service() {
        this.isEnableOAuth = true;
        this.refreshingAccessToken = false;
        this.refreshVersion = 0;
    }
    OAuth2Service.prototype.init = function (oauth2, localStorageGet, localStorageSet, localStorageRemove, localStoragePrefix) {
        /**
         * From /config/{env}.config html injection
         * Checks to ensure data exists for the current environment.
         */
        var _this = this;
        if (!oauth2) {
            console.error(NS, "Could not find \"oauth2\" object. Check webpack.config.js and ensure it is added for your environment.");
            return;
        }
        var mandatoryProps = [
            'authority',
            'clientId',
            'logout_uri',
            'redirect_uri',
            'post_logout_redirect_uri',
            'response_type',
            'clientRoot',
            'clientScope',
        ];
        if (mandatoryProps.some(function (propName) { return !oauth2[propName]; })) {
            console.warn(NS, "Check \"oauth2\" object and ensure all properties from list exist", mandatoryProps);
        }
        this.authSettings = oauth2;
        this.localStorageGet = localStorageGet;
        this.localStorageSet = localStorageSet;
        this.localStorageRemove = localStorageRemove;
        this.isEnableOAuth = !this.localStorageGet(LocalStorageKey.isLegacyLogin);
        this.localStoragePrefix = localStoragePrefix;
        var localStorageRefreshVersion = this.localStorageGet(LOCAL_STORAGE_REFRESH_VERSION);
        if (localStorageRefreshVersion) {
            this.refreshVersion = parseInt(localStorageRefreshVersion, 10);
        }
        else {
            this.localStorageSet(LOCAL_STORAGE_REFRESH_VERSION, this.refreshVersion);
        }
        window.addEventListener("storage", function (event) {
            if (event.key === _this.localStoragePrefix + LocalStorageKey.idToken && event.newValue !== event.oldValue) {
                try {
                    var newValue = JSON.parse(event.newValue);
                    if (!newValue) {
                        window.location.href = _this.authSettings.post_logout_redirect_uri;
                    }
                }
                catch (e) {
                    // console.log('error parsing value, ignore please', e);
                }
            }
        });
    };
    // this method for handle multiple tabs login
    OAuth2Service.prototype.isRefreshVersionSame = function () {
        var localStorageRefreshVersion = this.localStorageGet(LOCAL_STORAGE_REFRESH_VERSION);
        if (localStorageRefreshVersion) {
            var refreshVersion = parseInt(localStorageRefreshVersion, 10);
            if (refreshVersion > this.refreshVersion) {
                this.refreshVersion = refreshVersion;
                return false;
            }
            return true;
        }
        else {
            this.localStorageSet(LOCAL_STORAGE_REFRESH_VERSION, this.refreshVersion);
            return true;
        }
    };
    OAuth2Service.prototype.setIsEnableOAuth = function (isEnableOAuth) {
        this.isEnableOAuth = isEnableOAuth;
        this.localStorageSet(LocalStorageKey.isLegacyLogin, !isEnableOAuth);
    };
    OAuth2Service.prototype.getIsEnableOAuth = function () {
        return this.isEnableOAuth;
    };
    OAuth2Service.prototype.callOAuth = function (state) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var issuer, as, client, code_verifier, code_challenge, code_challenge_method, authorizationUrl;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.removeStoredDataForOauth();
                        issuer = new URL(this.authSettings.authority);
                        return [4 /*yield*/, oauth2
                                .discoveryRequest(issuer)
                                .then(function (response) { return oauth2.processDiscoveryResponse(issuer, response); })];
                    case 1:
                        as = _b.sent();
                        client = {
                            client_id: this.authSettings.clientId,
                            token_endpoint_auth_method: 'none',
                        };
                        if (((_a = as.code_challenge_methods_supported) === null || _a === void 0 ? void 0 : _a.includes('S256')) !== true) {
                            // This example assumes S256 PKCE support is signalled
                            // If it isn't supported, random `nonce` must be used for CSRF protection.
                            throw new Error();
                        }
                        code_verifier = oauth2.generateRandomCodeVerifier();
                        return [4 /*yield*/, oauth2.calculatePKCECodeChallenge(code_verifier)];
                    case 2:
                        code_challenge = _b.sent();
                        code_challenge_method = 'S256';
                        authorizationUrl = new URL(as.authorization_endpoint);
                        authorizationUrl.searchParams.set('client_id', client.client_id);
                        authorizationUrl.searchParams.set('code_challenge', code_challenge);
                        authorizationUrl.searchParams.set('code_challenge_method', code_challenge_method);
                        authorizationUrl.searchParams.set('redirect_uri', this.authSettings.redirect_uri);
                        authorizationUrl.searchParams.set('response_type', 'code');
                        authorizationUrl.searchParams.set('scope', this.authSettings.clientScope);
                        if (state) {
                            authorizationUrl.searchParams.set('state', state);
                        }
                        this.localStorageSet(LocalStorageKey.authorisationServer, JSON.stringify(as));
                        this.localStorageSet(LocalStorageKey.client, JSON.stringify(client));
                        this.localStorageSet(LocalStorageKey.codeVerifier, code_verifier);
                        return [2 /*return*/, authorizationUrl.href];
                }
            });
        });
    };
    OAuth2Service.prototype.login = function (usePopUp, state) {
        if (usePopUp === void 0) { usePopUp = true; }
        return __awaiter(this, void 0, void 0, function () {
            var newWindow;
            return __generator(this, function (_a) {
                if (usePopUp) {
                    newWindow = window.open('', 'login-window', POPUP_WINDOW_CONFIGURE);
                }
                this.callOAuth(state).then(function (url) {
                    // pop up a new window for login
                    if (usePopUp && newWindow) {
                        newWindow.location.href = url;
                    }
                    else {
                        // open in same window
                        window.location.href = url;
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    OAuth2Service.prototype.getOAuthToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var authorisationServer, client, codeVerifier, currentUrl, params, response, challenges, _i, challenges_1, challenge, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        authorisationServer = JSON.parse(this.localStorageGet(LocalStorageKey.authorisationServer) || '{}');
                        client = JSON.parse(this.localStorageGet(LocalStorageKey.client) || '{}');
                        codeVerifier = this.localStorageGet(LocalStorageKey.codeVerifier) || '';
                        currentUrl = new URL(window.location.href);
                        // follow line for the error of unexpected parameter.
                        currentUrl.searchParams.delete('state');
                        params = oauth2.validateAuthResponse(authorisationServer, client, currentUrl, oauth2.expectNoState);
                        if (oauth2.isOAuth2Error(params)) {
                            console.log('error', params);
                            throw new Error(); // Handle OAuth 2.0 redirect error
                        }
                        return [4 /*yield*/, oauth2.authorizationCodeGrantRequest(authorisationServer, client, params, this.authSettings.redirect_uri, codeVerifier)];
                    case 1:
                        response = _a.sent();
                        if ((challenges = oauth2.parseWwwAuthenticateChallenges(response))) {
                            for (_i = 0, challenges_1 = challenges; _i < challenges_1.length; _i++) {
                                challenge = challenges_1[_i];
                                console.log('challenge', challenge);
                            }
                            throw new Error(); // Handle www-authenticate challenges as needed
                        }
                        return [4 /*yield*/, oauth2.processAuthorizationCodeOpenIDResponse(authorisationServer, client, response)];
                    case 2:
                        result = _a.sent();
                        if (oauth2.isOAuth2Error(result)) {
                            throw new Error(result.error); // Handle OAuth 2.0 response body error
                        }
                        this.setTokenToStorage(result);
                        return [2 /*return*/, result.access_token];
                }
            });
        });
    };
    OAuth2Service.prototype.refreshAccessToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var client, authorisationServer, authorisationServerString, clientString, issuer_1, refreshToken, response, result, token, tokenError_1, sessionExpiredURL_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // for the case when the token is being refreshed, wait for the token to be refreshed
                        if (this.refreshingAccessToken) {
                            return [2 /*return*/, new Promise(function (resolve, reject) {
                                    var intervalId = setInterval(function () {
                                        if (!_this.refreshingAccessToken) {
                                            clearInterval(intervalId);
                                            resolve(_this.getOAuth2AccessToken());
                                        }
                                    }, 1000);
                                })];
                        }
                        // for the case that other tab refreshed token already
                        if (!this.isRefreshVersionSame()) {
                            return [2 /*return*/, Promise.resolve(this.getOAuth2AccessToken())];
                        }
                        this.refreshingAccessToken = true;
                        authorisationServerString = this.localStorageGet(LocalStorageKey.authorisationServer);
                        clientString = this.localStorageGet(LocalStorageKey.client);
                        if (!(!authorisationServerString || !clientString)) return [3 /*break*/, 2];
                        issuer_1 = new URL(this.authSettings.authority);
                        return [4 /*yield*/, oauth2
                                .discoveryRequest(issuer_1)
                                .then(function (response) { return oauth2.processDiscoveryResponse(issuer_1, response); })];
                    case 1:
                        authorisationServer = _a.sent();
                        client = {
                            client_id: this.authSettings.clientId,
                            token_endpoint_auth_method: 'none',
                        };
                        return [3 /*break*/, 3];
                    case 2:
                        authorisationServer = JSON.parse(authorisationServerString);
                        client = JSON.parse(clientString);
                        _a.label = 3;
                    case 3:
                        refreshToken = this.localStorageGet(LocalStorageKey.refreshToken);
                        return [4 /*yield*/, oauth2.refreshTokenGrantRequest(authorisationServer, client, refreshToken)];
                    case 4:
                        response = _a.sent();
                        return [4 /*yield*/, oauth2.processRefreshTokenResponse(authorisationServer, client, response)];
                    case 5:
                        result = _a.sent();
                        if (!oauth2.isOAuth2Error(result)) return [3 /*break*/, 11];
                        if (!(response.status === 400 && result.error === 'invalid_grant')) return [3 /*break*/, 10];
                        token = '';
                        _a.label = 6;
                    case 6:
                        _a.trys.push([6, 8, , 9]);
                        return [4 /*yield*/, this.getOAuthToken()];
                    case 7:
                        // get AccessToken and refresh token again
                        token = _a.sent();
                        return [3 /*break*/, 9];
                    case 8:
                        tokenError_1 = _a.sent();
                        console.log('tokenError - need to get a new token', tokenError_1);
                        sessionExpiredURL_1 = new URL(this.authSettings.clientRoot);
                        sessionExpiredURL_1.searchParams.set('session_expired', 'true');
                        this.refreshingAccessToken = false;
                        this.logout().finally(function () {
                            _this.removeStoredDataForOauth();
                            window.location.replace(sessionExpiredURL_1.href);
                        });
                        // window.alert('warning, error')
                        return [2 /*return*/, ''];
                    case 9:
                        this.refreshingAccessToken = false;
                        return [2 /*return*/, Promise.resolve(token)];
                    case 10:
                        this.refreshingAccessToken = false;
                        throw new Error(); // Handle OAuth 2.0 response body error
                    case 11:
                        if (result) {
                            this.refreshVersion += 1;
                            this.localStorageSet(LOCAL_STORAGE_REFRESH_VERSION, this.refreshVersion);
                        }
                        this.setTokenToStorage(result);
                        this.refreshingAccessToken = false;
                        return [2 /*return*/, Promise.resolve(result.access_token)];
                }
            });
        });
    };
    OAuth2Service.prototype.parseState = function (state) {
        var stateParams = state.split('&');
        var stateObj = {};
        stateParams.forEach(function (param) {
            var paramArr = param.split('=');
            stateObj[paramArr[0]] = paramArr[1];
        });
        return stateObj;
    };
    OAuth2Service.prototype.setTokenToStorage = function (result) {
        this.setOAuth2AccessToken(result.access_token);
        this.setOAuth2RefreshToken(result.refresh_token || '');
        this.setOAuth2IdToken(result.id_token || '');
    };
    OAuth2Service.prototype.getOAuth2AccessToken = function () {
        //todo as it used for both admin and diary, so read from local storage, add redux store will be better if separate them
        return this.localStorageGet(LocalStorageKey.accessToken);
    };
    OAuth2Service.prototype.setOAuth2AccessToken = function (accessToken) {
        return this.localStorageSet(LocalStorageKey.accessToken, accessToken);
    };
    OAuth2Service.prototype.getOAuth2RefreshToken = function () {
        return this.localStorageGet(LocalStorageKey.refreshToken);
    };
    OAuth2Service.prototype.setOAuth2RefreshToken = function (refreshToken) {
        return this.localStorageSet(LocalStorageKey.refreshToken, refreshToken || '');
    };
    OAuth2Service.prototype.getOAuth2IdToken = function () {
        return this.localStorageGet(LocalStorageKey.idToken);
    };
    OAuth2Service.prototype.setOAuth2IdToken = function (idToken) {
        return this.localStorageSet(LocalStorageKey.idToken, idToken);
    };
    OAuth2Service.prototype.getBearerToken = function () {
        return 'Bearer ' + this.getOAuth2AccessToken();
    };
    OAuth2Service.prototype.deleteCookies = function () {
        var allCookies = document.cookie.split(';');
        for (var i = 0; i < allCookies.length; i++) {
            document.cookie = allCookies[i] + '=;expires=' + new Date(0).toUTCString();
        }
    };
    OAuth2Service.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            var logoutIdToken, iamLogoutURL;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        logoutIdToken = this.getOAuth2IdToken();
                        if (!logoutIdToken) return [3 /*break*/, 2];
                        iamLogoutURL = new URL("" + this.authSettings.authority + this.authSettings.logout_uri);
                        iamLogoutURL.searchParams.set('id_token_hint', logoutIdToken);
                        iamLogoutURL.searchParams.set('client_id', this.authSettings.clientId);
                        return [4 /*yield*/, fetch(iamLogoutURL.toString())];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /***
     * This method is for refreshing the token in the background
     * @param accessToken - if not passed, it will take the token from local storage
     * @param newTokenCallback - callback function to be called when the new token is received, will be called with the new token as parameter
     * @param errorCallBack - callback function to be called when there is an error, will be called with the error as parameter
     * @param secondsBeforeTokenExpires - seconds before the token expires, default is 30 seconds
     */
    OAuth2Service.prototype.periodicalCheckForTokenValidity = function (accessToken, newTokenCallback, errorCallBack, secondsBeforeTokenExpires) {
        var _this = this;
        if (accessToken === void 0) { accessToken = null; }
        if (newTokenCallback === void 0) { newTokenCallback = null; }
        if (errorCallBack === void 0) { errorCallBack = null; }
        if (secondsBeforeTokenExpires === void 0) { secondsBeforeTokenExpires = 30; }
        var token = accessToken || this.getOAuth2AccessToken();
        var accessTokenClaims = this.parseJwt(token);
        var now = Date.now() / 1000;
        var randomSeconds = Math.floor(Math.random() * 60) + 1; // random seconds between 1 and 60
        // console.log('randomSeconds-----------------------', randomSeconds);
        var count = accessTokenClaims.exp - now - secondsBeforeTokenExpires;
        // let count = secondsBeforeTokenExpires + 40;
        // if token is expired, return false
        if (count <= 0) {
            return false;
        }
        count -= randomSeconds;
        // console.log('count-----------------------', count);
        // if already a timeout is set, clear it
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
        this.timeoutId = setTimeout(function () {
            _this.refreshAccessToken().then(function (newToken) {
                if (newTokenCallback) {
                    newTokenCallback(newToken);
                }
                _this.setOAuth2AccessToken(newToken);
                _this.periodicalCheckForTokenValidity(newToken, newTokenCallback);
            }).catch(function (error) {
                console.log('error refreshing token', error);
                if (errorCallBack) {
                    errorCallBack(error);
                }
            });
        }, count * 1000);
        return true;
    };
    OAuth2Service.prototype.checkForTokenValidity = function (accessToken) {
        if (!accessToken) {
            return false;
        }
        var accessTokenClaims = this.parseJwt(accessToken);
        var isTokenValid = this.tokenValid(accessTokenClaims);
        return isTokenValid;
    };
    OAuth2Service.prototype.checkForUserAuth = function () {
        return __awaiter(this, void 0, void 0, function () {
            var accessToken, accessTokenClaims, isTokenValid, refreshToken, refreshTokenClaims, isRefreshTokenValid, newAccessToken, newAccessTokenClaims, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        accessToken = this.getOAuth2AccessToken();
                        if (!accessToken) {
                            return [2 /*return*/, false];
                        }
                        accessTokenClaims = this.parseJwt(accessToken);
                        isTokenValid = this.tokenValid(accessTokenClaims);
                        if (isTokenValid) {
                            return [2 /*return*/, true];
                        }
                        refreshToken = this.getOAuth2RefreshToken();
                        if (!refreshToken) {
                            return [2 /*return*/, false];
                        }
                        refreshTokenClaims = this.parseJwt(refreshToken);
                        isRefreshTokenValid = this.tokenValid(refreshTokenClaims);
                        if (!!isRefreshTokenValid) return [3 /*break*/, 1];
                        return [2 /*return*/, false];
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.refreshAccessToken()];
                    case 2:
                        newAccessToken = _a.sent();
                        newAccessTokenClaims = this.parseJwt(newAccessToken);
                        return [2 /*return*/, this.tokenValid(newAccessTokenClaims)];
                    case 3:
                        e_1 = _a.sent();
                        return [2 /*return*/, false];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    OAuth2Service.prototype.removeStoredDataForOauth = function () {
        this.localStorageRemove(LocalStorageKey.accessToken);
        this.localStorageRemove(LocalStorageKey.authorisationServer);
        this.localStorageRemove(LocalStorageKey.client);
        this.localStorageRemove(LocalStorageKey.codeVerifier);
        this.localStorageRemove(LocalStorageKey.refreshToken);
        this.localStorageRemove(LocalStorageKey.idToken);
        this.localStorageRemove(NgLocalStorageKey.account);
        this.localStorageRemove(NgLocalStorageKey.venue);
        this.localStorageRemove(NgLocalStorageKey.isManager);
        this.localStorageRemove(NgLocalStorageKey.couchUsers);
        this.localStorageRemove(LocalStorageKey.isLegacyLogin);
        this.localStorageRemove(SYNCED_LOGOUT);
        this.localStorageRemove(LOCAL_STORAGE_REFRESH_VERSION);
        this.deleteCookies();
    };
    OAuth2Service.prototype.parseJwt = function (token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(window
            .atob(base64)
            .split('')
            .map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
            .join(''));
        return JSON.parse(jsonPayload);
    };
    OAuth2Service.prototype.tokenValid = function (claims) {
        var now = Date.now() / 1000;
        return now < claims.exp;
    };
    return OAuth2Service;
}());
var instance = new OAuth2Service();
export default instance;
// @ts-ignore
window['OAuth2Service'] = instance;
